import React, {useState, useEffect} from 'react';
import { useLocation, useParams } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';

import StepsComponent from './StepsComponent';
import SideBar from './SideBar';
import ViewTitle from './TitleComponent';
import WelcomeBanner from './WelcomeBannerComponent';

const routes = [
  { path:"/", title:"LOGIN" },
  { path: "/plan", title: "SELECT YOUR SUBSCRIPTION PLAN LEVEL AND ADD-ONS", step:1 },
  { path: "/signUp", title: "ENTER YOUR INFORMATION TO CREATE YOUR ACCOUNT", step: 2 },
  { path: "/payment", title: "ENTER YOUR PAYMENT METHOD TO CREATE YOUR ACCOUNT", step: 3 },
  { path: "/invoice", title: "YOUR ORDER HAS BEEN CONFIRMED", step: 4 },
  { path: "/createVirtualSpace", title: "CREATE YOUR MARQUET VIRTUAL SPACE", step: 5 },
  { path: "/myAccount", title: "MY ACCOUNT" },
  { path: "/mySubscriptions", title: "SELECT A SUBSCRIPTION TO VIEW OR EDIT"},
  { path: "/mySubscription", title: "MY SUBSCRIPTION" },
  { path: "/billingActivity", title: "BILLING & PAYMENTS" },
  { path: "/myVirtualSpaces", title: "MANAGE YOUR VIRTUAL SPACES" },
  { path: "/changeSubscription", title: "SELECT A NEW PLAN FOR THE SUBSCRIPTION"},

  { path: "/forgot-password", title: "FORGOT PASSWORD" },
  { path: "/reset-password", title: "RESET PASSWORD"},

  { path: "/404", title: "PAGE NOT FOUND" }
]

const Layout = ({children}) => {

  const location = useLocation();

  const [step, setStep] = useState(null)
  const [title, setTitle] = useState("")

  useEffect(() => {
    let path = location.pathname
    path = path.split("/")
    path = `/${path[1]}`
    const currentRoute = routes.find(route => route.path === path);
    if (currentRoute !== undefined){
      setTitle(currentRoute.title)
      if (currentRoute.step !== undefined) {
        setStep(currentRoute.step)
      } else {
        setStep(null)
      }
    }
  },[location])

  if(step === null){
    return (
      <div className='marquet--subscriptions'>
        <Header/>
        <SideBar/>
        <WelcomeBanner/>
        <ViewTitle title={title} />
        <div className='marquet--subscriptions--container'>
          {children}
        </div>
        <Footer/>
      </div>
    )
  }else{
    return (
      <div className='marquet--subscriptions subscriptions--steps'>
        <Header/>
        <WelcomeBanner/>
        <StepsComponent step={step}/>
        <ViewTitle step={step} title={title} />
        <SideBar/>
        <div className='marquet--subscriptions--container'>
          {children}
        </div>
        <Footer/>
      </div>
    )
  }
}

export default Layout